import {envAutoDetector} from './envAutoDetector';

export const generateEnvDomain = (authHost: any) => {
  let envDomain = authHost;
  const originEnvPart = envAutoDetector();
  const authHostEnvPart = envAutoDetector(authHost);

  if (originEnvPart !== authHostEnvPart) {
    envDomain = authHost.replace(authHostEnvPart, originEnvPart);
  }

  return envDomain;
};

